export default {
  header: 'No se pudo cargar tu pedido',
  text: 'Algo salió mal al preparar tu pedido. Tu cesta está a salvo, inténtalo de nuevo.',
  retry: 'Intentar de nuevo',
  address_header: 'Necesitamos tu dirección de entrega',
  address_text: 'No podemos calcular tu total hasta saber dónde entregar. Tu carrito está a salvo.',
  address_action: 'Añadir dirección de entrega',
  back_checkout: 'Volver a tu pedido',
  back_basket: 'Volver a tu carrito',
};
